import { render, staticRenderFns } from "./ClientAdvisor.vue?vue&type=template&id=4a76fb79&"
import script from "./ClientAdvisor.vue?vue&type=script&lang=js&"
export * from "./ClientAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports